<div class="header list-header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  <astral-button class="btn-list-header" variant="secondary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="onCreateItem()"></astral-button>
</div>
<div class="header list-header d-flex d-md-none align-items-center">
  <h1 class="w-100">{{ title | translate }}</h1>
  <astral-button class="btn-list-header" variant="secondary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="onCreateItem()"></astral-button>
</div>

@if (!accessControlEnabled) {
  <app-information-block [text]="'LOCATION_ACCESS.FEATURE_ACTIVATION_DESCRIPTION' | translate"></app-information-block>
}

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)"></app-filter>

<app-paged-list-view
  [columnDefinition]="columnDefinition"
  [contextMenuDefinition]="contextMenuDefinition"
  [menuDefinition]="menuDefinition"
  [itemsSource]="itemsSource"
  [totalCount]="totalResults"
  [preferencesKey]="preferencesKey"
  (onPageChange)="pagingChanged($event)"
  (onSortChange)="sortChanged($event)"
  (rowClick)="onRowClicked($event)"
  [isToolbarSticky]="true"
  >
</app-paged-list-view>
